import { fetchApi } from "../DataApi/fetchApi";

export const getToken = async () => {
  const requestOptions = {
    method: "GET",
  };

  try {
    const response = await fetchApi({
      endpoint: "/web/login",
      requestOptions,
      headers: {},
      checkSession: false,
    });

    if (typeof response === "string") {
      var startIndex =
        response.indexOf('csrf_token: "') + 'csrf_token: "'.length;
      var endIndex = response.indexOf('"', startIndex);
      var csrfToken = response.substring(startIndex, endIndex);
      // console.log(csrfToken);

      if (typeof csrfToken === "string") {
        return { success: true, token: csrfToken };
      } else {
        return { success: false, error: "CSRF token not found" };
      }
    } else {
      console.error("Response is not a string");
      return { success: false, error: "Response is not a string" };
    }
  } catch (error) {
    console.error("An error occurred:", error);
    return { success: false, error: error.message };
  }
};
